import { THEMES, type ThemeKey, type ThemeDef } from '@/types/wedding';

interface Props {
  theme: ThemeKey;
  onChange: (theme: ThemeKey) => void;
}

/* 테마 색을 그대로 입혀 보여주는 실제 청첩장 미니 미리보기 */
function ThemeThumb({ theme }: { theme: ThemeDef }) {
  return (
    <div className={`ed-theme-thumb inv theme-${theme.key}`} aria-hidden="true">
      <div className="ed-thumb-hero">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20editorial%20wedding%20portrait%20of%20a%20couple%20standing%20close%20in%20a%20sunlit%20garden%2C%20warm%20neutral%20cream%20and%20beige%20tones%2C%20soft%20natural%20light%2C%20shallow%20depth%20of%20field%2C%20timeless%20elegant%20mood%2C%20high%20detail%2C%20minimal%20romantic%20composition&width=560&height=420&seq=theme-thumb-couple&orientation=landscape"
          alt=""
        />
        <span className="ed-thumb-tint" />
        <span className="ed-thumb-hero-in">
          <span className="ed-thumb-eyebrow">We invite you</span>
          <span className="ed-thumb-names">
            도윤 <i>&amp;</i> 서연
          </span>
          <span className="ed-thumb-date">2026. 05. 16</span>
        </span>
      </div>
      <div className="ed-thumb-body">
        <span className="ed-thumb-kicker" />
        <span className="ed-thumb-card">
          <span className="ed-thumb-line" />
          <span className="ed-thumb-line short" />
        </span>
        <span className="ed-thumb-cta" />
      </div>
    </div>
  );
}

export default function ThemePicker({ theme, onChange }: Props) {
  return (
    <div className="ed-section">
      <div className="ed-section-head">
        <span className="step">
          <i className="ri-palette-line" aria-hidden="true" />
        </span>
        <h2>디자인 선택</h2>
        <span className="hint">{THEMES.length}종 중 하나를 골라 주세요</span>
      </div>
      <p className="ed-desc">
        각 카드에 실제 청첩장 분위기를 미리 보여드려요. 고른 디자인은 오른쪽 미리보기에 바로
        반영되고, 언제든 다시 바꿀 수 있어요.
      </p>

      <div className="ed-theme-grid">
        {THEMES.map((t) => (
          <button
            key={t.key}
            type="button"
            className={`ed-theme-card ${theme === t.key ? 'is-active' : ''}`}
            onClick={() => onChange(t.key)}
            aria-pressed={theme === t.key}
          >
            <ThemeThumb theme={t} />
            <div className="meta">
              <div>
                <h3>{t.name}</h3>
                <p>{t.desc}</p>
              </div>
              <span className="ed-theme-check" aria-hidden="true">
                <i className="ri-check-line" />
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}